"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@/store/useAuthStore";
import { getArtists } from "../api";
import type { ArtistsQueryParams, ArtistsResponse } from "../types";
export function useArtists(params, options) {
  const $ = _c(25);
  const t0 = params.page ?? 1;
  const t1 = params.perPage ?? 15;
  let t2;
  if ($[0] !== params.name || $[1] !== params.order || $[2] !== params.order_by || $[3] !== params.username || $[4] !== t0 || $[5] !== t1) {
    t2 = ["artists", t0, t1, params.name, params.username, params.order, params.order_by];
    $[0] = params.name;
    $[1] = params.order;
    $[2] = params.order_by;
    $[3] = params.username;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const key = t2;
  const isFallbackPayload = options?.initialData?.message === "offline_fallback";
  const initialForKey = !isFallbackPayload && options?.initialData && (params.page ?? 1) === options.initialData.data.page.current_page && (params.perPage ?? 15) === Number(options.initialData.data.page.per_page) ? options.initialData : undefined;
  const queryClient = useQueryClient();
  const token = useAuthStore(_temp);
  let t3;
  if ($[7] !== params) {
    t3 = () => getArtists(params);
    $[7] = params;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = initialForKey && token ? 0 : undefined;
  let t5;
  if ($[9] !== initialForKey || $[10] !== key || $[11] !== t3 || $[12] !== t4) {
    t5 = {
      queryKey: key,
      queryFn: t3,
      staleTime: 60000,
      gcTime: 300000,
      placeholderData: _temp2,
      initialData: initialForKey,
      initialDataUpdatedAt: t4
    };
    $[9] = initialForKey;
    $[10] = key;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const query = useQuery(t5);
  const needsPersonalRead = Boolean(token) && !query.isFetchedAfterMount && !query.isFetching;
  const {
    refetch
  } = query;
  let t6;
  let t7;
  if ($[14] !== needsPersonalRead || $[15] !== refetch) {
    t6 = () => {
      if (needsPersonalRead) {
        refetch();
      }
    };
    t7 = [needsPersonalRead, refetch];
    $[14] = needsPersonalRead;
    $[15] = refetch;
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  useEffect(t6, t7);
  const t8 = Boolean(token) && query.isFetchedAfterMount && !query.isPlaceholderData;
  let t9;
  if ($[18] !== key || $[19] !== queryClient) {
    t9 = () => queryClient.resetQueries({
      queryKey: key
    });
    $[18] = key;
    $[19] = queryClient;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== query || $[22] !== t8 || $[23] !== t9) {
    t10 = {
      ...query,
      personal: t8,
      reset: t9
    };
    $[21] = query;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function _temp2(previous) {
  return previous;
}
function _temp(s) {
  return s.token;
}